import {FormConfig} from "../form/form.config";
import {FormModelText} from "../form/form.model.text";
import {FormModel} from "../form/form.model.abstract";
import {Validators, ValidatorFn, UntypedFormGroup} from "@angular/forms";
import {FormModelRadio} from "../form/form.model.radio";
import {ValidationService} from "../services/validation.service";
import {FormModelNumber} from "../form/form.model.number";
import {FormModelHidden} from "../form/form.model.hidden";
import {ModeratConstants} from "../moderat/moderat.constants";
import {FormModelDates} from "../form/form.model.dates";
import {FormModelTextSelect} from "../form/form.model.textselect";
import {HeizcheckConstants} from "../heizcheck/heizcheck.constants";
import {EnergyMapService} from '../energy-map/services/energy.map.service';
import {FormModelCheckboxes} from "../form/form.model.checkboxes";

/**
 * Configuratuion for the input of the first chapter in the moderat advisor.
 * @inheritDoc
 */
export class VerbrauchsanalyseForm extends FormConfig {

  /**
   * HOlds the modus for the form. Can be either moc or hec
   */
  modus: string = 'moc';

  /**
   * some data is needed here for validation
   */
  public anfrage: any;

  /**
   * @inheritDoc
   * @protected
   *
   * ATTENTION: Some of these values are alos used in ErgebnisComponent.moFieldMappings, check them
   */
  protected fields: FormModel[] = [
    // basisinformationen
    new FormModelRadio('nutzungstyp', ['hauseigentuemer', 'wohnungseigentuemer', 'hausverwalter', 'mieter'], [Validators.required], null, null, false),
    new FormModelRadio('gebaeudetyp', ['einfamilienhaus', 'zweifamilienhaus', 'mehrfamilienhaus'], [Validators.required], null, null, false),
    new FormModelRadio('gebaeude_denkmalschutz', ['ja', 'nein'], [Validators.required], null, null, false),
    // value of heizungstyp must be mapped in the backend for dezentral2
    new FormModelRadio('heizungstyp', ['zentral', 'dezentral', 'dezentral2'], [Validators.required], null, null, false),
    new FormModelRadio('energietraeger_name', ['erdgas', 'heizoel', 'fernwaerme', 'fluessiggas', 'holzpellets', 'waermepumpe', 'waermepumpe_luft', 'waermepumpe_wasser'], [Validators.required], null, null, false),
    (new FormModelText('gebaeudebaujahr', [Validators.required, ValidationService.buildingYear], null, null, false, 'number')).setClasses('small-field'),
    (new FormModelText('postleitzahl', [Validators.required, ValidationService.postalCode], null, null, false)).setClasses('small-field'),
    new FormModelHidden('ort'),
    new FormModelNumber('bewohneranzahl', [Validators.required, Validators.min(1), Validators.max(ModeratConstants.FORM_PEOPLE_MAX)],  null, ModeratConstants.FORM_PEOPLE_DEFAULT, false),
    new FormModelNumber('gebaeude_stockwerke', [Validators.required, Validators.min(ModeratConstants.FORM_FLOOR_MIN_MFH), Validators.max(ModeratConstants.FORM_FLOOR_MAX_MFH)],  null, ModeratConstants.FORM_FLOOR_MIN_MFH, false),

    // wohnung
    new FormModelRadio('wohnung_etage', ['erdgeschoss', 'zwischengeschoss', 'obergeschoss', 'dachgeschoss'], [Validators.required], null, null, false),
    (new FormModelRadio('gebaeude_dachgeschoss_ausgebaut', ['ja', 'nein'], [Validators.required], null, null, false)).setInactive(),
    new FormModelRadio('wohnung_anzahl_aussenwaende', [1, 2, 3, 4], [Validators.required], null, null, false),
    (new FormModelText('wohnung_flaeche', [Validators.required, Validators.min(HeizcheckConstants.FLAT_AREA_MIN), Validators.max(HeizcheckConstants.FLAT_AREA_MAX)], 'm2', null, false, 'number')).setClasses('small-field'),

    // heizsystem
    (new FormModelText('gebaeude_flaeche', [Validators.required, Validators.min(0)], 'm2', null, false, 'number')).setClasses('small-field'),
    new FormModelNumber('anzahl_wohneinheiten', [Validators.required, Validators.min(3)], null, null, false),
    new FormModelRadio('keller_status', ['nicht_vorhanden', 'vorhanden', 'vorhanden_beheizt'], [Validators.required], null, null, false),
    new FormModelRadio('warmwasser_bereitungsart', ['zentral', 'dezentral'], [Validators.required], null, null, false),
    new FormModelRadio('warmwasser_messung', ['gemessen', 'geschaetzt'], [Validators.required], null, null, false),
    new FormModelRadio('zusatzheizung_vorhanden', ['ja', 'nein'], [Validators.required], null, null, false),
    (new FormModelRadio('zusatzheizung_energietraeger', ['brennholz', 'holzpellets', 'briketts'], [Validators.required], null, null, false)).setInactive(),
    new FormModelRadio('solarthermie_art', ['nicht_vorhanden', 'warmwasser', 'warmwasser_heizung'], [Validators.required], null, null, false),

    // verbrauchsdaten
    new FormModelDates('abrechnungszeitraum', ['abrechnung_von', 'abrechnung_bis'], [Validators.required, ValidationService.dateFormat],  null, [FormConfig.getFirstDayOfLastYear(), FormConfig.getLastDayOfLastYear()], true),
    new FormModelTextSelect('energietraeger_verbrauch', 'energietraeger_einheit', [Validators.required, ValidationService.greaterZero],  ['kwh', 'mwh', 'gj', 'liter', 'm3', 'kg', 't', 'm3_kondensat', 't_dampf'], [], true, 'number'),
    new FormModelText('energietraeger_kosten', [Validators.required, ValidationService.greaterZero],  'eur', null, true, 'number'),
    new FormModelText('heizkosten_gesamt', [ValidationService.greaterZero],  'eur', null, true, 'number'),
    new FormModelTextSelect('warmwasser_verbrauch', 'warmwasser_einheit', [Validators.required, Validators.min(0)],  ['m3', 'liter', 'kwh', 'mwh'], [], true, 'number'),
    new FormModelText('warmwasser_temperatur',  [Validators.required, Validators.min(ModeratConstants.FORM_WATER_TEMPERATURE_MIN), Validators.max(ModeratConstants.FORM_WATER_TEMPERATURE_MAX)], 'deg', ModeratConstants.FORM_WATER_TEMPERATURE_DEFAULT, true, 'number'),
    (new FormModelCheckboxes('warmwasser_verbrauch_bekannt', ['nein'], [], null, [], false)).setClasses('no-label reset-input'),
    (new FormModelTextSelect('zusatzheizung_verbrauch', 'zusatzheizung_einheit', [Validators.required, Validators.min(0)],  ['kg', 't', 'm3', 'rm', 'srm', 'ster', 'fm'], [], true, 'number')).setInactive(),
    (new FormModelCheckboxes('zusatzheizung_verbrauch_bekannt', ['nein'], [], null, [], false)).setClasses('no-label reset-input')
  ];

  /**
   * @inheritDoc
   * @protected
   */
  protected formValidators = [
    ...['', '1', '2', '3', '4', '5', '6', '7', '8', '9'].map(index => ValidationService.smallerEqual('energietraeger_kosten' + index, 'heizkosten_gesamt' + index)),
    ValidationService.dateRangeMinMax('abrechnung_von', 'abrechnung_bis', ModeratConstants.INVOICE_MIN_DAYS, ModeratConstants.INVOICE_MAX_DAYS, ['', '1', '2', '3', '4', '5', '6', '7', '8', '9']),
    ValidationService.dateInPast('abrechnung_bis', ModeratConstants.INVOICE_MIN_DAYS_IN_PAST),
    ValidationService.validateInvoiceDates(),
    VerbrauchsanalyseForm.dateAfterBuildingYear(this),
    VerbrauchsanalyseForm.apartmentSizeMinMax(this)
  ];

  /**
   * @inheritDoc
   */
  formValidatorsFields = {dateOverlapp: ['abrechnung_von', 'abrechnung_bis'], dateRangeMinMax: ['abrechnung_von', 'abrechnung_bis'], smallerEqual: ['energietraeger_kosten', 'heizkosten_gesamt']};

  /**
   * List of formfields where changes of the value, change other fields.
   */
  fieldsForFormChanges: string[] = ['gebaeudetyp', 'nutzungstyp', 'wohnung_etage', 'obergeschoss', 'gebaeude_dachgeschoss_ausgebaut', 'warmwasser_bereitungsart',
    'warmwasser_verbrauch', 'warmwasser_einheit', 'zusatzheizung_vorhanden', 'warmwasser_messung'];

  /**
   * The options for some fields that are dynamic, depending on other form fields
   * option heizungstyp['1-2familienhaus'] is a fallback for user with old result and pdf link
   */
  static readonly options: any = {
    'heizungstyp': {
      'mehrfamilienhaus': ['zentral', 'dezentral', 'dezentral2'],
      'einfamilienhaus': ['zentral', 'dezentral2'],
      'zweifamilienhaus': ['zentral', 'dezentral2'],
      '1-2familienhaus': ['zentral', 'dezentral2']
    },
    'energietraeger_einheit': {
      'strom': ['kwh'],
      'heizoel': ['liter'],
      'fernwaerme': ['kwh','mwh','gj','m3_kondensat','t_dampf'],
      'erdgas': ['kwh', 'm3'],
      'fluessiggas': ['liter', 'm3', 'kg'],
      'holzpellets': ['kg', 't'],
      'waermepumpe': ['kwh'],
      'waermepumpe_luft': ['kwh'],
      'waermepumpe_wasser': ['kwh']
    },
    'zusatzheizung_einheit': {
      'brennholz': ['rm', 'srm', 'm3', 'fm', 'kg'],
      'laubholz': ['rm', 'srm', 'm3', 'fm', 'kg'],
      'nadelholz': ['rm', 'srm', 'm3', 'fm', 'kg'],
      'briketts': ['kg', 't'],
      'holzpellets': ['kg', 't']
    },
    'warmwasser_einheit': {
      'gebaeude': ['m3', 'kwh', 'mwh'],
      'wohnung': ['m3', 'liter', 'kwh']
    },
    'warmwasser_bereitungsart': {
      'dezentral': ['zentral', 'zentral2', 'dezentral'],
      'zentral': ['zentral', 'dezentral'],
    }
  };

  constructor(protected energyMapService: EnergyMapService) {
    super();
  }

  /**
   * validates start date 'abrechnung_von' after the building year.
   * @param formConfig
   */
  static dateAfterBuildingYear(formConfig: VerbrauchsanalyseForm): ValidatorFn {
    return(formGroup: UntypedFormGroup) => {
      // check if there is a value in the field 'abrechnung_von'
      if(formGroup?.controls?.abrechnung_von?.value) {
        const buildingYear = formConfig?.anfrage?.verbrauchsanalyseInput?.gebaeudebaujahr;
        const startDate = formGroup?.controls?.abrechnung_von?.value;

        // check if there is a value of buildingYear and abrechnung_von
        if(buildingYear && formGroup?.controls?.abrechnung_von?.value) {
          const startYear = ValidationService.dateFromString(startDate)?.getFullYear();

          // validate if the startYear from abrechnung_von is after the buildingYear
          if(!startYear || startYear < buildingYear) {
            return {dateAfterBuildingYear: false};
          }
        }
      }
      return null;
    }
  }

  /**
   * Validates min and max size/value of each apartment area in relation to building area ('gebaeude_flaeche' / 'anzahl_wohneinheiten')
   * @param formConfig
   */
  static apartmentSizeMinMax(formConfig: VerbrauchsanalyseForm): ValidatorFn {
    return(formGroup: UntypedFormGroup) => {
      // check if there is a value in the field 'gebaeude_flaeche' and 'anzahl_wohneinheiten'
      if (formGroup?.controls?.anzahl_wohneinheiten?.value && formConfig?.anfrage?.gebaeudetyp === 'mehrfamilienhaus') {

        // const buildingArea = formGroup?.controls?.gebaeude_flaeche?.value;
        const buildingArea = formConfig?.anfrage?.verbrauchsanalyseInput?.gebaeude_flaeche;
        const apartmentCount = formGroup?.controls?.anzahl_wohneinheiten?.value;
        const apartmentSize = buildingArea / apartmentCount;

        if (apartmentSize < HeizcheckConstants.APARTMENT_SIZE_MIN ||
          apartmentSize > HeizcheckConstants.APARTMENT_SIZE_MAX) {
          return {apartmentSizeMinMax: false};
        }
      }
      return null;
    }
  }

  /**
   * @inheritDoc
   * @protected
   */
  protected groups: any = {};

  /**
   * HOlds the last set data
   */
  lastData: {[key: string]: any} = {};

  /**
   * Any time a field is updated, this method is called.
   * @param values
   */
  updateFields(values: {[key: string]: any}): void {
    // remember the last data that we set on this form
    this.lastData = {...this.lastData, ...values};

    // change value of field gebaeudetyp if there is still the value '1-2familienhaus' from old requests/results
    if(values.hasOwnProperty('gebaeudetyp') && values.gebaeudetyp === '1-2familienhaus') {
      values.gebaeudetyp = 'einfamilienhaus';
    }

    // changes based on field 'nutzungstyp'
    if(values.hasOwnProperty('nutzungstyp') === true) {
      if(values.nutzungstyp === 'wohnungseigentuemer') {
        // case 1: hide field gebaeudetyp
        this.deactivateField('gebaeudetyp');
        values.gebaeudetyp = 'mehrfamilienhaus';
        this.getField('gebaeudetyp').setValue('mehrfamilienhaus');
      }
      else {
        // case 2: show field gebaeudetyp
        this.activateField('gebaeudetyp');
      }

      // nutzungstyp + gebauedetyp
      if(values.hasOwnProperty('gebaeudetyp')) {
        // de/activate anzahl_wohneinheiten for eigentuemer in mfh
        if ((values.nutzungstyp === 'hauseigentuemer' || values.nutzungstyp === 'wohnungseigentuemer') && values.gebaeudetyp === 'mehrfamilienhaus') {
          this.activateField('anzahl_wohneinheiten');

          // preset wohneinheiten
          if (!values.anzahl_wohneinheiten && values.hasOwnProperty('gebaeude_flaeche')) {
            values.anzahl_wohneinheiten = Math.ceil(parseFloat(values.gebaeude_flaeche) / HeizcheckConstants.FLAT_AREA_AVERAGE);
          }
        } else {
          this.deactivateField('anzahl_wohneinheiten');
          values.anzahl_wohneinheiten = null;
        }
      }
    }

    // changes based on field 'gebaeudetyp'
    if(values.hasOwnProperty('gebaeudetyp') === true) {
      // set options for heating type
      this.setOptions('heizungstyp', VerbrauchsanalyseForm.options.heizungstyp[values.gebaeudetyp]);

      // reset older selection (if available)
      if(VerbrauchsanalyseForm.options.heizungstyp[values.gebaeudetyp]?.indexOf(values.heizungstyp) === -1) {
        values.heizungstyp = null;
      }

      if(values.gebaeudetyp !== 'mehrfamilienhaus') {
        // case 1: show field for inhabitants and update the field validator
        this.activateField('zusatzheizung_vorhanden');
        this.setFieldValidators('gebaeude_flaeche', [Validators.required, ValidationService.buildingAreaOneFamilyHouse]);
        this.getField('gebaeude_flaeche').setErrorId('gebaeude_flaeche.efh');
      }
      else {
        // case 2: hide field for inhabitants and update the field validator
        this.deactivateField('zusatzheizung_vorhanden');
        this.deactivateField('zusatzheizung_energietraeger');
        this.setFieldValidators('gebaeude_flaeche', [Validators.required, ValidationService.buildingAreaMultiFamilyHouse]);
        this.getField('gebaeude_flaeche').setErrorId('gebaeude_flaeche.mfh');

        // reset some values that are only allowed for single family houses
        values.zusatzheizung_vorhanden = null;
        values.zusatzheizung_energietraeger = null;
      }
    }

    // heating + building
    if(values.hasOwnProperty('heizungstyp') === true && values.hasOwnProperty('gebaeudetyp')) {
      // de/activate fields for apartements
      if(values.gebaeudetyp !== 'mehrfamilienhaus' || values.heizungstyp === 'zentral') {
        // apartements
        this.activateField('keller_status');
        this.activateField('solarthermie_art');
        // change options of warmwasser_verbrauch
        this.setOptions('warmwasser_einheit', VerbrauchsanalyseForm.options.warmwasser_einheit['gebaeude']);

        this.activateField('gebaeude_flaeche');
        this.deactivateField('wohnung_flaeche');
        this.deactivateField('wohnung_etage');
        this.deactivateField('wohnung_anzahl_aussenwaende');
        values.wohnung_flaeche = null;
        values.wohnung_etage = null;
        values.wohnung_anzahl_aussenwaende = null;
      }
      else {
        // building
        this.deactivateField('keller_status');
        this.deactivateField('solarthermie_art');
        values.keller_status = 'nicht_vorhanden';
        values.solarthermie_art = 'nicht_vorhanden';
        this.setOptions('warmwasser_einheit', VerbrauchsanalyseForm.options.warmwasser_einheit['wohnung']);

        this.activateField('wohnung_flaeche');
        this.activateField('wohnung_etage');
        this.activateField('wohnung_anzahl_aussenwaende');
        this.deactivateField('gebaeude_flaeche');

        values.gebaeude_flaeche = null;
      }

      // show bewohneranzahl for apartements
      if(values.gebaeudetyp !== 'mehrfamilienhaus' || values.heizungstyp !== 'zentral') {
        this.activateField('bewohneranzahl');
      }
      else {
        this.deactivateField('bewohneranzahl');
        values.bewohneranzahl = null;
      }
    }

    // based on gebaeudetyp, set some validators for the floor number
    if (values.hasOwnProperty('gebaeudetyp')) {
      if (values.gebaeudetyp === 'mehrfamilienhaus') {
        this.setFieldValidators('gebaeude_stockwerke', [
          Validators.required,
          Validators.min(ModeratConstants.FORM_FLOOR_MIN_MFH),
          Validators.max(ModeratConstants.FORM_FLOOR_MAX_MFH),
          ValidationService.allowIntegerOnly
        ]);
      }
      else {
        this.setFieldValidators('gebaeude_stockwerke', [
          Validators.required,
          Validators.min(ModeratConstants.FORM_FLOOR_MIN_EFH),
          Validators.max(ModeratConstants.FORM_FLOOR_MAX_EFH),
          ValidationService.allowIntegerOnly
        ]);
      }
    }

    // show gebaeude_stockwerke for EnergyMap
    if (values.hasOwnProperty('postleitzahl') && typeof this.anfrage !== 'undefined') {
      if (this.energyMapService.showEnergyMap(this.anfrage, 'heizcheck') === true) {
        this.activateField('gebaeude_stockwerke');
      }
      else {
        this.deactivateField('gebaeude_stockwerke');
        values.gebaeude_stockwerke = null;
      }
    }

    // heizkosten_gesamt
    if(values.hasOwnProperty('heizungstyp') === true && values.hasOwnProperty('gebaeudetyp') && values.hasOwnProperty('nutzungstyp')) {
      // de/activate fields for heating costs
      if ((values.heizungstyp === 'zentral' && values.gebaeudetyp === 'mehrfamilienhaus') ||
        (values.gebaeudetyp !== 'mehrfamilienhaus' && values.nutzungstyp === 'mieter')) {
        this.activateField('heizkosten_gesamt');
      }
      else {
        this.deactivateField('heizkosten_gesamt');
        values.heizkosten_gesamt = null;
      }
    }

    // decentralized heating
    if(values.hasOwnProperty('heizungstyp') === true) {
      this.setOptions('warmwasser_bereitungsart', VerbrauchsanalyseForm.options.warmwasser_bereitungsart[values.heizungstyp]);

      if(values.hasOwnProperty('warmwasser_bereitungsart') &&
        VerbrauchsanalyseForm.options.warmwasser_bereitungsart[values.heizungstyp]?.indexOf(values.heizungstyp) === -1) {
        // reset old selection
        values.warmwasser_bereitungsart = null;
      }

      // case: Etagenheizung
      if(values.heizungstyp === 'dezentral') {
        this.activateField('warmwasser_bereitungsart');
        this.deactivateField('energietraeger_name');
        values.energietraeger_name = 'erdgas';
      }
      // case nachtspeicher
      else if(values.heizungstyp === 'dezentral2') {
        this.deactivateField('energietraeger_name');
        this.deactivateField('warmwasser_bereitungsart');
        values.warmwasser_bereitungsart = 'dezentral';
        values.energietraeger_name = 'strom';
      }
      else {
        this.activateField('energietraeger_name');
        this.activateField('warmwasser_bereitungsart');
      }
    }

    // update energietraeger einheit options and set to first available option
    if(values.hasOwnProperty('energietraeger_name') === true) {
      this.setOptions('energietraeger_einheit', VerbrauchsanalyseForm.options.energietraeger_einheit[values.energietraeger_name]);

      // check if the (maybe) selected energy source is valid
      if(values.energietraeger_einheit && VerbrauchsanalyseForm.options.energietraeger_einheit[values.energietraeger_name]?.indexOf(values.energietraeger_einheit) === -1) {
        this.getField('energietraeger_einheit').setValue(VerbrauchsanalyseForm.options.energietraeger_einheit[values.energietraeger_name][0]);
        values.energietraeger_einheit = VerbrauchsanalyseForm.options.energietraeger_einheit[values.energietraeger_name][0];
      }
      if(!values.energietraeger_einheit) {
        // preset energy source
        this.getField('energietraeger_einheit').setValue(VerbrauchsanalyseForm.options.energietraeger_einheit[values.energietraeger_name][0]);
        values.energietraeger_einheit = VerbrauchsanalyseForm.options.energietraeger_einheit[values.energietraeger_name][0];
      }
    }

    // changes based on field 'warmwasser_bereitungsart'
    if(values.hasOwnProperty('warmwasser_bereitungsart') === true) {
      if(values.warmwasser_bereitungsart?.startsWith('zentral')) {
        // case 1: show field warmwasser_messung
        this.activateField('warmwasser_messung');
      }
      else {
        // case 2: hide field warmwasser_messung
        this.deactivateField('warmwasser_messung');
        this.deactivateField('warmwasser_verbrauch');
        this.deactivateField('warmwasser_temperatur');
        this.deactivateField('solarthermie_art');
        values.warmwasser_messung = null;
        values.warmwasser_verbrauch = null;
        values.warmwasser_temperatur = null;
        values.warmwasser_einheit = null;
        values.solarthermie_art = 'nicht_vorhanden';
      }
    }

    // changes based on field 'zusatzheizung_vorhanden'
    if(values.hasOwnProperty('zusatzheizung_vorhanden') === true) {
      if(values.zusatzheizung_vorhanden === 'ja' && values.gebaeudetyp !== 'mehrfamilienhaus') {
        // case 1: extra heating = ja and single family house
        this.activateField('zusatzheizung_energietraeger');
        this.activateField('zusatzheizung_verbrauch_bekannt');
        this.activateField('zusatzheizung_verbrauch');
      }
      else {
        // case 2: multi-family house or extra heating = no
        this.deactivateField('zusatzheizung_energietraeger');
        this.deactivateField('zusatzheizung_verbrauch_bekannt');
        this.deactivateField('zusatzheizung_verbrauch');
        // reset the values
        values.zusatzheizung_energietraeger = null;
        values.zusatzheizung_verbrauch_bekannt = null;
        values.zusatzheizung_verbrauch = null;

        // check if there are more extra heating fields with postfix from additional invoices
        for (let i = 1; i<=5; i++) {
          const checkFields = [
            'zusatzheizung_verbrauch' + i,
            'zusatzheizung_einheit' + i,
            'zusatzheizung_verbrauch_bekannt' + i + '_nein'
          ];

          for(let field of checkFields) {
            // if there are more fields reset values
            if(values.hasOwnProperty(field)) {
              values[field] = null;
            }
          }
        }
      }
    }

    // update zusatzheizung energietraeger options and set to first available options
    if(values.hasOwnProperty('zusatzheizung_energietraeger') === true && values.zusatzheizung_energietraeger) {
      this.setOptions('zusatzheizung_einheit', VerbrauchsanalyseForm.options.zusatzheizung_einheit[values.zusatzheizung_energietraeger]);

      if(!values.zusatzheizung_einheit || VerbrauchsanalyseForm.options.zusatzheizung_einheit[values.zusatzheizung_energietraeger].indexOf(values.zusatzheizung_einheit) === -1) {
        this.getField('zusatzheizung_einheit').setValue(VerbrauchsanalyseForm.options.zusatzheizung_einheit[values.zusatzheizung_energietraeger][0]);
        values.zusatzheizung_einheit = VerbrauchsanalyseForm.options.zusatzheizung_einheit[values.zusatzheizung_energietraeger][0];
      }
    }

    // changes based on field 'warmwasser_messung'
    if(values.hasOwnProperty('warmwasser_messung') === true) {
      if(values.warmwasser_messung === 'gemessen') {
        // case 1: hot water is measured
        this.activateField('warmwasser_verbrauch');
        this.activateField('warmwasser_verbrauch_bekannt');
        this.activateField('warmwasser_temperatur');
      }
      else {
        // case 2: hot water is not measured
        this.deactivateField('warmwasser_verbrauch');
        this.deactivateField('warmwasser_verbrauch_bekannt');
        this.deactivateField('warmwasser_temperatur');
        values.warmwasser_verbrauch = null;
        values.warmwasser_temperatur = null;
        values.warmwasser_einheit = null;

        // check if there are more hot water measurement fields with postfix from additional invoices
        for (let i = 1; i<=5; i++) {
          const checkFields = [
            'warmwasser_verbrauch' + i,
            'warmwasser_einheit' + i,
            'warmwasser_verbrauch_bekannt' + i + '_nein',
            'warmwasser_temperatur' + i
          ];

          for(let field of checkFields) {
            // if there are more fields reset values
            if(values.hasOwnProperty(field)) {
              values[field] = null;
            }
          }
        }
      }
    }

    // get the field 'warmwasser_temperatur' from formModel
    const fieldWarmwasserTemperatur = this.fields.find(field => field.id === 'warmwasser_temperatur');

    // changes of warmwasser_einheit
    if (values.hasOwnProperty('warmwasser_einheit')) {
      if (values.warmwasser_einheit === 'm3' || values.warmwasser_einheit === 'liter') {
        // activate 'warmwasser_temperatur' only if it is not active already
        if (fieldWarmwasserTemperatur && fieldWarmwasserTemperatur.isActive() === false) {
          this.activateField('warmwasser_temperatur');
        }
      }
      else {
        // deactivate and reset 'warmwasser_temperatur' only if it is active already
        if (fieldWarmwasserTemperatur && fieldWarmwasserTemperatur.isActive() === true) {
          this.deactivateField('warmwasser_temperatur');
          values.warmwasser_temperatur = null;
        }
      }
    }

    // changes based on field 'wohnung_etage'
    if(values.hasOwnProperty('wohnung_etage')) {
      if (values.wohnung_etage === 'obergeschoss') {
        this.activateField('gebaeude_dachgeschoss_ausgebaut');
      }
      else {
        this.deactivateField('gebaeude_dachgeschoss_ausgebaut');
        values.gebaeude_dachgeschoss_ausgebaut = null;
      }
    }
  }

  /**
   * In this function all dynamic changes of the form is done. Based on selection options or value other fields are shown/hidden, options changed and validators adapted.
   *
   * @inheritDoc
   * @param values
   * @protected
   */
  protected onSetData(values: {[key: string]: any}): void {
    this.updateFields(values);
  }

  /**
   * @inheritDoc
   * @protected
   */
  protected onChange() {
    // check if the form has some fields which value changes other fields.
    if(this.fieldsForFormChanges.find(field => this.form.get(field)) !== undefined) {
      this.updateFields(this.getData());
    }
  }

  /**
   * @inheritDoc
   * @param fieldId
   */
  getInfoPostfix(fieldId: string = null): string {
    switch(fieldId) {
      case 'abrechnungszeitraum':
        // special inline help for these energysources
        if(this.lastData.hasOwnProperty('energietraeger_name') && ['heizoel', 'fluessiggas', 'holzpellets'].indexOf(this.lastData.energietraeger_name) > -1) {
          return "tank";
        }
    }

    return super.getInfoPostfix(fieldId);
  }

  /**
   * @inheritDoc
   * @param step
   * @param id
   */
  getLabel(step: string, id: string): string {
    // overwrite labelkey for field heizungstyp
    if(step === 'heizcheck' && id === 'heizungstyp' && (this.lastData?.nutzungstyp === 'wohnungseigentuemer' || this.lastData?.nutzungstyp === 'mieter')) {
      return super.getLabel(step, id) + '.wohnung';
    }

    return super.getLabel(step, id);
  }

}
